// extracted by mini-css-extract-plugin
export default {"slide":"slide__slide__ZAYyU","slideInFromRight":"slide__slideInFromRight__ejdk6"};